import React from "react";
import { Modal, Table } from "react-bootstrap"
import styled from "styled-components";
import { getNFeTransporters } from "../../../../../../../api/nfe";
import { formatDocument } from "../../../../../../../utils";
import LoadingContainer from "../../../../../../../_components/LoadingContainer"
import Button from "../../../../../../../_components/Button"
import { CreateNFeContext } from "../../../Context";

const TR = styled.tr`
    cursor:pointer
`
export default props => {

    const [show, ShowModal] = React.useState(false)
    const [data, setData] = React.useState([])
    const [loading, setLoading] = React.useState(false)

    async function loadTransporters() {
        setLoading(true)
        await getNFeTransporters().then(data => setData(data))
        setLoading(false)
    }

    async function openModal() {
        ShowModal(true)
        await loadTransporters()
    }
    function closeModal() {
        ShowModal(false)
    }

    return <CreateNFeContext.Consumer>
        {
            context => {
                const transporter = context.nfe["transporter"] || {}
                const { addTransporter, removeTransporter } = context["handlers"]

                return <React.Fragment>
                    <Button data-cy-test="#nfe-issuer-button-open-modal-search-transporter" onClick={openModal}>
                        Adicionar Transportadora
                    </Button>
                    <Table
                        className={transporter.name ? "" : "d-none"}
                        striped
                        bordered
                        hover
                        responsive >

                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>CPF/CNPJ</th>
                                <th>IE</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>
                                    {transporter.name}
                                </td>
                                <td>
                                    {formatDocument(transporter.cpf || transporter.cnpj)}
                                </td>
                                <td>
                                    {transporter.state_registry}
                                </td>
                                <td onClick={removeTransporter}>
                                    <i className="fas fa-trash-alt btn btn-outline-danger btn-sm"></i>
                                </td>
                            </tr>
                        </tbody>


                    </Table>
                    <Modal show={show} size="lg" onHide={closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <h2>
                                    Selecione a transportadora
                                </h2>
                            </Modal.Title>
                        </Modal.Header>

                        <LoadingContainer loading={loading}>
                            <Modal.Body>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>CPF/CNPJ</th>
                                            <th>Razão Social</th>
                                            <th>IE</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data.map((item, index) => {
                                                const key = `nfe-issuer-transporter-${item.id}-${index}`
                                                const document = formatDocument(item.cpf || item.cnpj)
                                                return <TR
                                                    data-cy-test={`#search-transporter-list-result-index=${index}`}
                                                    key={key}
                                                    onClick={() => {
                                                        addTransporter(item)
                                                        ShowModal(false)
                                                    }}>
                                                    <td>
                                                        {document}
                                                    </td>
                                                    <td>
                                                        {item.name}
                                                    </td>
                                                    <td>
                                                        {item.state_registry}
                                                    </td>
                                                    <td>
                                                        adicionar <i className="fas fa-plus"></i>
                                                    </td>
                                                </TR>
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </Modal.Body>
                        </LoadingContainer>

                    </Modal>
                </React.Fragment>
            }
        }
    </CreateNFeContext.Consumer>

}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/ShippingTransporter/NFeTransporter/index.jsx